export const initialTranslationExceptionTypes = () => [
  {
    isAdded: false,
    languageCode: "DE",
    name: "",
  },
  {
    isAdded: false,
    languageCode: "ES",
    name: "",
  },
  {
    isAdded: false,
    languageCode: "FR",
    name: "",
  },
  {
    isAdded: false,
    languageCode: "NL",
    name: "",
  },
  {
    isAdded: false,
    languageCode: "SE",
    name: "",
  },
  {
    isAdded: false,
    languageCode: "DA",
    name: "",
  },
];
